import * as FIELD_NAME from 'constant/form-item-names'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editDiscovery } from 'action/discovery'
import { Form, Modal } from 'antd'
import PropTypes from 'prop-types'
import DiscoveryForm from 'view/page/discovery-management/component/discovery-form'
import FormModal from 'view/component/form-modal'
import * as NUMBER from 'constant/number'
import _ from 'lodash'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.title} has been successfully edited${response.is_draft ? ' and saved as a draft.' : '.'}`,
  title: 'Discovery edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.message,
  title: 'An Error has occured'
})

const EditDiscovery = ({ discovery, editDiscovery, submitting }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()

  const handleClick = () => setVisible(true)

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editDiscovery({ ...values, description_meta: form.getFieldValue(FIELD_NAME.DESCRIPTION_META), uuid: discovery.uuid })
      setVisible(false)
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }
  discovery.category_uuid = _.compact(discovery.category_uuid)
  return (
    <>
      <a onClick={handleClick}>Edit Discovery</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={submitting}
        onCancel={() => {
          setVisible(false)
          form.setFieldsValue(discovery)
        }}
        title='Edit Discovery'
        visible={visible}
      >
        <DiscoveryForm
          discovery={discovery}
          form={form}
        />
      </FormModal>
    </>
  )
}

EditDiscovery.propTypes = {
  discovery: PropTypes.object,
  editDiscovery: PropTypes.func,
  submitting: PropTypes.bool
}

const mapStateToProps = (state) => ({
  submitting: state.loader.discoverySubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editDiscovery: bindActionCreators(editDiscovery, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditDiscovery)
